export default "__VITE_ASSET__CTrqnCDz__"